'use client';

import styled from 'styled-components';
import { Box } from '@mui/material';

export const SearchContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  max-width: 100%;
  overflow: hidden;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }

  & > * {
    flex: 1;
    min-width: 0;
  }

  & > button {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  @media (max-width: 767px) {
    gap: 12px;

    & > *:not(button) {
      flex: 0 0 100%;
    }

    & > button {
      margin-left: auto;
    }
  }
`;

